import { handleResponse, handleError } from "./apiUtils.js";
import { generateClient } from 'aws-amplify/api';
import * as queries from '../graphql/queries.js';
import * as mutations from '../graphql/mutations.js';
import { client } from "webpack-dev-server/bin/cli-flags.js";

const gClient = generateClient();

export async function createMeal(parameters) {

  parameters.IPAddress = '27.0.0.1';
  console.log(parameters); // debug
  let response = await gClient.graphql(
    {
      query: mutations.mealApIcreateMeal, 
      variables: parameters
    }
  )
    .catch(handleError);

  // console.log(response.data.mealAPIcreateMeal) // debug
  return response.data.mealAPIcreateMeal;
}

export async function updateMeal(parameters) {
  parameters.IPAddress = '27.0.0.1';
  let response = await gClient.graphql(
    {
      query: mutations.mealApIupdateMeal, 
      variables: parameters
    }
  )
    .catch(handleError);

  // console.log(response.data.mealAPIcreateMeal) // debug
  return response.data.mealAPIupdateMeal;
}

export async function getMeal(parameters) {
  let response = await gClient.graphql(
    {
      query: queries.mealApIgetMeal, 
      variables: parameters
    }
  )
    .catch(handleError);

  // console.log(response.data.mealAPIcreateMeal) // debug
  return response.data.mealAPIgetMeal;
}

export async function deleteMeal(parameters) {
  parameters.IPAddress = '27.0.0.1';
  let response = await gClient.graphql(
    {
      query: mutations.mealApIdeleteMeal, 
      variables: parameters
    }
  )
    .catch(handleError);

  return response.data.mealAPIdeleteMeal;
}
